<template>
    <i
        class="l-ss-c-offer-like-icon"
        :class="{ 'l-ss-c-offer-like-icon-active': isFavouriteOffer }"
        @click.prevent.stop="onChange(!isFavouriteOffer)"
        :style="style"
        v-html="currentIcon"></i>
</template>

<script>
    import { computed } from '@/lib/vue-composition-api.js';

    import iconLike from '@/core/assets/images/icons/like.svg';
    import useOfferFavouritesController from '@/core/components/offer/offer-favourites/use-offer-favourites-controller';

    export default {
        props: {
            offer: {
                type: Object,
            },
            settings: {
                type: Object,
            },
            favouritesSettings: {
                type: Object,
            },
        },
        setup(props) {
            const { offer, settings, favouritesSettings } = props;
            const { style, icon } = settings;

            const currentIcon = computed(() => {
                if (icon && icon.default) {
                    const defaultIcon = icon.default;
                    const activeIcon = icon.active;

                    if (isFavouriteOffer.value) {
                        return activeIcon || defaultIcon;
                    } else {
                        return defaultIcon;
                    }
                }

                return iconLike;
            });

            const { isFavouriteOffer, onChange } = useOfferFavouritesController(offer, favouritesSettings);

            return {
                currentIcon,
                style,
                isFavouriteOffer,
                onChange,
            };
        },
    };
</script>

<style scoped>

</style>
